import { getActionName } from './../ruleConfigure/config'

import React from 'react'
function getTypeValue(type, value) {
  const map = {
    "status":[
      "处理中",
      "已处理",
      "处理失败",
    ],
    "limitType": [
      "单次",
      "多次",
      "无限制",
      "周期限制",
    ],
    "outputClass": [
      "积分",
      "学分",
      "证书",
      "经验",
      "阶段"
    ],
    "limitCycleType": [
      "年",
      "月",
      "周",
      "日",
    ],
    "bizType": [
      "课程",
      "考试",
      "问卷",
      "直播",
      "考试模版组",
      "考试分类",
      "题目分类",
      "课件",
      "线下课程",
      "培训中心",
      "教室",
      "岗位能力考核项目",
      "路径必修",
      "路径选修",
      "审核",
      "报名",
      "评语",
      "场地",
      "栏目应用",
      "TMS远程认证",
      "内容",
      "证书管理",
      "话题",
      "活动",
      "帖子",
      "系列化课程",
      "互动直播",
      "推荐",
      "学分",
      "规则"
    ]
  }
  return map[type][value]
}
export const recordTabelColumns = (self) => [

  {
    title: '处理行为',
    dataIndex: 'actionType',
    key: 'actionType',
    render: (text, record) => (
      <div>{getActionName(record['actionType'])}</div>
    ),
    width: 60
  },
  {
    title: '处理业务类型',
    dataIndex: 'bizType',
    key: 'bizType',
    render: (text, record) => (
      <div>{getTypeValue(`bizType`, record['bizType'])}</div>
    ),
    width: 40
  },
  {
    title: '处理业务Id',
    dataIndex: 'bizId',
    key: 'bizId',
    width: 60
  },
  {
    title: '接收时间',
    dataIndex: 'exeTime',
    key: 'exeTime',
    width: 60
  },
  {
    title: '处理时间',
    dataIndex: 'outputTime',
    key: 'outputTime',
    width: 60
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    render: (text, record) => (
      <div>{getTypeValue(`status`, record['status'])}</div>
    ),
    width: 40
  },

]
export const outputInfoColumns = (self) => [
  {
    title: '产物类型',
    dataIndex: 'outputClass',
    key: 'outputClass',
    width: 100,
    render: (text, record) => (
      <div>{getTypeValue(`outputClass`, record['outputClass'])}</div>
    ),
  },
  {
    title: '产物',
    dataIndex: 'outputValue',
    key: 'outputValue',
    width: 300,
    render: (text, record) => (
      <div>{record.outputName || record.outputValue || ''}</div>
    ),
  },
  {
    title: '产物标识',
    dataIndex: 'outputFlagName',
    key: 'outputFlagName',
    width: 300,
  },
  {
    title: '限制类型',
    dataIndex: 'limitType',
    key: 'limitType',
    width: 100,
    render: (text, record) => (
      <div>{getTypeValue(`limitType`, record['limitType'])}</div>
    ),
  },
  {
    title: '限制周期',
    dataIndex: 'limitCycleType',
    key: 'limitCycleType',
    width: 100,
    render: (text, record) => (
      <div>{getTypeValue(`limitCycleType`, record['limitCycleType'])}</div>
    ),
  },
  {
    title: '限制次数',
    dataIndex: 'limitCount',
    key: 'limitCount',
    width: 100,
  },
  // {
  //   title: '最新修改时间',
  //   dataIndex: 'updateTime',
  //   key: 'updateTime',
  //   width: 300
  // },

];
